import { render, staticRenderFns } from "./RefillsStockTitle.vue?vue&type=template&id=2249fd56&scoped=true"
import script from "./RefillsStockTitle.vue?vue&type=script&lang=js"
export * from "./RefillsStockTitle.vue?vue&type=script&lang=js"
import style0 from "./RefillsStockTitle.vue?vue&type=style&index=0&id=2249fd56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2249fd56",
  null
  
)

export default component.exports